import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'model-select',
  template: `
  <div class="dynamic-field form-input form-group" [formGroup]="group">
    <label>{{map.name}}</label>
    <input type="text" [formControlName]="map.name" />
  </div>
  `,
  styles: []
})
export class SelectComponent {
    map: any;
    group: FormGroup;

}
